var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-/-Inline-/-Success",
    transform: "translate(-16.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-Tick",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "checkmark",
    strokeWidth: 1,
    fillRule: "evenodd",
    fill: "#43B02A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0342857,0.115080745 C5.45888199,0.115080745 0.128198758,5.44576398 0.128198758,12.0214658 C0.128198758,18.5968696 5.45888199,23.9277019 12.0342857,23.9277019 C18.6096894,23.9277019 23.9403727,18.5968696 23.9403727,12.0214658 C23.9403727,5.44576398 18.6096894,0.115080745 12.0342857,0.115080745 Z M12.0342857,1.1072795 C18.0521739,1.1072795 22.9475776,6.0032795 22.9475776,12.0214658 C22.9475776,18.039205 18.0521739,22.935354 12.0342857,22.935354 C6.01639752,22.935354 1.11950311,18.039205 1.11950311,12.0214658 C1.11950311,6.0032795 6.01639752,1.1072795 12.0342857,1.1072795 Z M18.8332919,7.20581366 C18.6395031,7.01187578 18.3264596,7.01187578 18.1326708,7.20581366 L8.56099379,16.7767453 L5.43950311,13.6551056 C5.24571429,13.4611677 4.93118012,13.4611677 4.7373913,13.6551056 C4.54360248,13.8487453 4.54360248,14.1626832 4.7373913,14.3566211 L8.21068323,17.8291677 C8.30757764,17.925913 8.43428571,17.9743602 8.56099379,17.9743602 C8.68770186,17.9743602 8.81590062,17.925913 8.91279503,17.8291677 L18.8332919,7.90718012 C19.0270807,7.7133913 19.0270807,7.39960248 18.8332919,7.20581366 Z",
    id: "icon_85"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8794703f4a96c30de3392244eb1622e5.svg";
export { ForwardRef as ReactComponent };